import { CompsFilteredSchema } from '@hcs/types';

export type CompsListTypes =
  | keyof CompsFilteredSchema
  | 'selected'
  | 'appraisal';

export enum CompsListViewType {
  Card = 'card',
  Table = 'table',
  Compare = 'compare',
}
